import { defaultTheme } from 'sletat-ui-components2/dist/theme';
import { cssToObject } from '../../../../../utils/cssToObject';
import { LESS_512_MEDIA_QUERY } from '../../../../consts/adaptive';

export const styles = {
    buttonGroup: {
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        width: '100%',
        paddingTop: 20,
    },

    button: {
        ...cssToObject(defaultTheme.theme.mixin.fontButtonM),
        fontFamily: 'Open Sans, Arial, sans-serif',
        width: '100%',
        padding: [4, 12],
        backgroundColor: defaultTheme.theme.colors.accent,
        color: defaultTheme.theme.colors.lightBlue,
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',

        ['&:first-of-type']: {
            marginRight: 2,
        },

        ['&:hover']: {
            background: defaultTheme.theme.colors.paleBlue,
        },
    },

    [LESS_512_MEDIA_QUERY]: {
        button: {
            fontSize: 12,
            marginRight: 0,
        },
    },

    active: {
        backgroundColor: defaultTheme.theme.colors.lightBlue,
        color: defaultTheme.theme.colors.primary,

        ['&:hover']: {
            background: defaultTheme.theme.colors.lightBlue,
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
